import { render, staticRenderFns } from "./BatchesFilter.vue?vue&type=template&id=c90113b2&scoped=true"
import script from "./BatchesFilter.vue?vue&type=script&lang=js"
export * from "./BatchesFilter.vue?vue&type=script&lang=js"
import style0 from "./BatchesFilter.vue?vue&type=style&index=0&id=c90113b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c90113b2",
  null
  
)

export default component.exports